import { isEqual } from "lodash-es";
import { createSelectorCreator, lruMemoize } from "reselect";

export const createDeepEqualSelector = createSelectorCreator(
  lruMemoize,
  isEqual,
);
